import { atom } from 'recoil';
import { FilterDef } from '../../../constants/FinanceModels';

export const STATE_TABLE_UPDATING = atom<boolean>({
    key: "payableinvoices-state-table-updating",
    default: false
});

export const STATE_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'payableinvoices-state-active-filters',
    default: []
});

/*export const  STATE_INSIGHT_MODAL = atom <any>({
    key: 'payableinvoices-state-insight-modal',
    default : undefined
});*/